<template>
    <p :class="['field', { invalid: isInvalid }]">
        <label v-if="required" :for="id">
            <slot></slot>
            *<span v-if="helpText"> ({{ helpText }})</span>
        </label>
        <label v-else :for="id">
            <slot></slot>
            <span v-if="helpText"> ({{ helpText }})</span>
        </label>
        <span class="half_size">
            <input :type="inputType" :autocomplete="autocomplete"
                   size="30"
                   :id="id"
                   :name="id"
                   :value="value"
                   :disabled="disabled"
                   @input="emitChange($event.target.value)"
                   @focus="emitFocus"
                   @blur="emitBlur(true)"
            />
            <span class="invalid_help" v-if="isInvalid && invalidText">{{ invalidText }}</span>
        </span>
        <input
				type="submit"
				class="btn"
				:value="'Uložit' | translate"
				@click.prevent.stop="emitSubmit"
		/>
    </p>
</template>

<script>
	export default {
		name: "TextInputWithSubmit",
		data() {
			return {
				touched: false,
				forcedInvalid: false,
				invalidText: null,
			}
		},
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			id: String,
			value: [String, Number],
			helpText: {
				type: String,
				default: ''
			},
			required: {
				type: Boolean,
				default: false
			},
			inputType: {
				type: String,
				default: 'text'
			},
			disabled: {
				type: Boolean,
				default: false
			},
			autocomplete: {
				type: String,
				default: 'new-password'
			}
		},
		computed: {
			isInvalid() {
				return (this.touched && this.required && !this.value) || this.isForcedInvalid
			},
			isForcedInvalid() {
				return this.forcedInvalid
			}
		},
		methods: {
			emitChange(value) {
				this.$emit('change', value)
				this.setTouched(true)
			},
			emitFocus() {
				this.$emit('focus', true)
			},
			setTouched(value) {
				this.touched = value
			},
			emitBlur(value) {
				this.setTouched(value)
				this.$emit('blur', value)
			},
			setForcedInvalid(value = false, invalidText = null) {
				this.forcedInvalid = value
				this.invalidText = value === false ? null : invalidText
			},
            emitSubmit() {
				this.$emit('submit')
            }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/devices/TextInputWithSubmit.vue